import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/userSlice";
import subscriptionReducer from "./slices/subscriptionSlice";
import reevaluationReducer from "./slices/reevaluationSlice";
import { reducer as dataReducer } from './reducer';
import { Store } from './types';

// 루트 리듀서
const rootReducer = {
  user: userReducer,
  subscription: subscriptionReducer,
  reevaluation: reevaluationReducer,
  data: dataReducer,
};

// 스토어 생성
export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// RootState 및 AppDispatch 타입 정의
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Store 타입 내보내기
export type { Store } from './types';
